import {
  ActivityType,
  BolusState,
} from "@tandemdiabetes/sugarmate-api-react-client"

import { ModalBody } from "@tandemdiabetes/sugarmate-react-components"
import { EventModalHeader } from "../EventModalHeader"
import type { BolusEventProps } from "./BolusEventProps"
import { BolusSubItem } from "./BolusSubItem"
import { BolusTypeValue } from "./BolusTypeValue"
import { GlucoseValue } from "./GlucoseValue"
import { InProgress } from "./InProgress"

import styles from "src/styles/entryModal.module.scss"
import { BolusInformation } from "src/types"

const BolusInformationArray: BolusInformation[] = [
  BolusInformation.InitiatedAt,
  BolusInformation.StoppedAt,
  BolusInformation.TotalRequestedUnits,
  BolusInformation.CorrectionBolus,
  BolusInformation.BolusNow,
  BolusInformation.BolusLater,
  BolusInformation.RequestedDuration,
  BolusInformation.CarbsEntered,
  BolusInformation.InsulinEntered,
  BolusInformation.PumpCalculated,
]

export function BolusEventModal(props: BolusEventProps) {
  const { userEvent } = props

  return (
    <>
      <EventModalHeader
        activityType={ActivityType.Bolus}
        userEvent={userEvent}
        closeBtnId="bolus-event-close-btn"
      />
      <ModalBody className={styles.modalBody}>
        {userEvent.bolus?.state === BolusState.InProgress && <InProgress />}
        <BolusTypeValue userEvent={userEvent} />
        <GlucoseValue userEvent={userEvent} />
        {BolusInformationArray.map((bolusInfo) => (
          <BolusSubItem
            key={bolusInfo}
            bolusInfo={bolusInfo}
            userEvent={userEvent}
          />
        ))}
      </ModalBody>
    </>
  )
}
